import { createContext, useContext, useState } from "react";

const ConsultationContext = createContext({ open: false, setOpen: () => {}, prefill: {}, openWith: () => {} });

export const ConsultationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openWith = (data = {}) => {
    setPrefill(data);
    setOpen(true);
  };

  return (
    <ConsultationContext.Provider value={{ open, setOpen, prefill, openWith }}>
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultation = () => useContext(ConsultationContext);
